import { render, staticRenderFns } from "./TaskProgress.vue?vue&type=template&id=1a00b84c&"
import script from "./TaskProgress.vue?vue&type=script&lang=js&"
export * from "./TaskProgress.vue?vue&type=script&lang=js&"
import style0 from "./TaskProgress.vue?vue&type=style&index=0&id=1a00b84c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports